import {Visibility, VisibilityOff} from '@mui/icons-material'
import React from 'react'

export function getVisibilityIcon(visible: boolean) {
	return Boolean(visible) ? <Visibility color={'action'}/> : <VisibilityOff color={'action'}/>
}